import React from 'react';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import propTypes from 'prop-types';
import ReactTable from 'react-table';
import { validateNRIC } from '../../utils/common';
import { getUploadColumns } from './actions';
import validation from './validation';
import './upload.css';


import {
    spmfcloudFunctionUrl,
} from '../../actions/salesforces';

class BeneUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fileName: '',
            parsedFile: [],
            loading: false,
            allChecked: false,
            errorMessage: [],
            validationError: false,
            validation: []
        };
        this.tempFile = null;
        this.readFile = this.readFile.bind(this);
        this.parseFileOnServer = this.parseFileOnServer.bind(this);
        this.getUploadColumns = getUploadColumns.bind(this);
        this.createApplication = this.createApplication.bind(this);
        this.validationUpload = this.validationUpload.bind(this);
    }

    componentWillMount() {

    }

    readFile(event) {
        this.tempFile = event.target.files[0];
        this.setState({
            fileName: this.tempFile.name.replace(/ /ig, '-'),
        });
    }


    async parseFileOnServer(e) {//sending excel file to mw to get json data
        e.preventDefault();
        const { recordType } = this.props.salesforce;
        const formData = new FormData();
        this.setState({ loading: true });

        formData.append('template', this.tempFile);
        formData.append('beneficiaryRecordType', recordType.Beneficiary);
        formData.append('schoolId', this.state.schoolId);
        try {
        // Upload the whole file to server for parsing process
            const fetchConfig = {
                method: 'POST',
                headers: {
                    'hash-token': this.props.user.siteToken.hash,
                    'Cache-Control': 'no-cache',
                },
                body: formData,
                timeout: 5000,
                mode: 'cors',
            };

            const response = await fetch(`${spmfcloudFunctionUrl}/excel/parse`, fetchConfig).then(res => res.json());
            let data = response.rows
            if (response.status !== 200) {
                throw new Error(response.message);
            }

            const errorValidation = this.validationUpload(response.rows);//handle validation before save to sf
            // const errorValidation = [];
            errorValidation.forEach(error => {
                if(error.type === 'duplicate' && error.category === 'nricError'){
                    if(error.duplicate ==='multi-line'){
                        data.forEach((application, index) => {
                            if(application.beneficiary.ID_Number__c === error.value){
                                data[index].validationError = data[index].validationError !== undefined ? [...data[index].validationError, error]:  [error]
                            }
                        })
                    }else{
                        data[error.row].validationError = data[error.row].validationError !== undefined ? [...data[error.row].validationError, error]: [error]
                    }
                }else{
                    data[error.row].validationError = data[error.row].validationError !== undefined ? [...data[error.row].validationError, error] : [error]
                }
            })

            this.setState({ loading: false, parsedFile: data, validationError: errorValidation.length > 0, validation: errorValidation });
        } catch (error) {
            swal({
                text: error.message,
                type: 'error',
                title: 'Failed',
            });
            this.setState({ loading: false });
        }
    }

    async createApplication() {//save value to salesforce
        const { parsedFile, loading } = this.state;
        if (loading) return;
        this.setState({ loading: true });
        
        const rows = parsedFile.filter(o => o.uploadStatus === 1);
        const requestUploads = rows
            .map(o => fetch(`${spmfcloudFunctionUrl}/excel/salesforce`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'hash-token': this.props.user.siteToken.hash,
                },
                body: JSON.stringify(o),
                mode: 'cors',
            }).then(res => res.json()));
        const errorMessage = [];
        const results = await Promise.all(requestUploads);
        results.forEach((o) => {
            const index = parsedFile.findIndex(x => x.tempId === o.tempId);
            if (o.status === 200) {
                parsedFile[index].uploadStatus = 2;
                parsedFile[index].sfId = o.application.id;
            } else {
                let validation = null;
                if (o.validation) {
                    validation = o.validation.map(val => <li>{val.msg}</li>);
                }
                errorMessage.push(
                    <div style={{ color: '#000' }}>
                        <p>Row {index + 1}: {o.message === 'INVALID_REQUEST' ? ' Has some error(s)' : o.message}</p>
                        <ol>
                            {validation}
                        </ol>
                    </div>
                );
            }
        });
        let swalMessages = '';
        if (results.filter(o => o.status === 200).length === results.length) {
            swalMessages = {
                title: 'All rows succesfully uploaded',
                type: 'success',
            };
        } else if (results.filter(o => o.status === 200).length < results.length &&
            results.filter(o => o.status === 200).length !== 0) {
            swalMessages = {
                title: 'Some rows successfully uploaded',
                type: 'warning',
            };
        } else {
            swalMessages = {
                title: 'No rows uploaded',
                type: 'error',
            };
        }
        swal({
            text: `${results.filter(o => o.status === 200).length} records succesfully uploaded`,
            ...swalMessages,
        });

        this.setState({ loading: false, errorMessage, parsedFile });
    }

    validationUpload(file){//validation for each field with function from validation file
        const nricError = validation.multipleValidationIdNumber(file)
        const postalError = validation.postalValidation(file)
        const DOBError = validation.DOBValidation(file)
        const phoneNumberError = validation.phoneNumberValidation(file)
        const emailError = validation.emailValidation(file)
        const householdMemberError = validation.householdMembersValidation(file)
        const monthlyHouseholdError = validation.monthlyHouseholdValidation(file)
        const monthlyPerCapitaError = validation.monthlyPerCapitaValidation(file)
        const picklistError = validation.picklistValidation(file)
        
        const allError = [...nricError, ...postalError, ...DOBError, ...phoneNumberError, ...emailError, ...monthlyHouseholdError, ...monthlyPerCapitaError, ...householdMemberError, ...picklistError]
        return allError
    }

    render() {
        const { fileName, loading, parsedFile, errorMessage } = this.state;
        let refInputFile = null;
        return (
            <div className="registrationForm container-fluid">
                <div className="col-md-12" >
                    <div className="">
                        <h3 style={{ color: '#0590ba' }}>Beneficiary Upload</h3>
                    </div>
                </div>
                <div className="col-md-12 print">
                    <div className="col-md-12" id="logoHeader">
                        <div className="row form-upload">
                            <div className="col-sm-6">
                                <input type="text" value={fileName} className="form-control" />
                                <br />
                                <label className="fileContainer">
                                    Choose File
                                    <input
                                        onChange={this.readFile}
                                        onClick={(e) => { e.target.value = null; }}
                                        type="file"
                                        accept=".xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                                        // className="form-control-file"
                                        aria-describedby="fileHelp1"
                                        multiple
                                        ref={(e) => { refInputFile = e; }}
                                    />
                                </label>
                            </div>
                            <div className="col-sm-6">
                                <div className="btn-group">
                                    <a
                                        href={null}
                                        className="btn btn-default"
                                        type="button"
                                        onClick={this.parseFileOnServer}
                                        disabled={loading}
                                    >
                                        <i className="fa fa-paper-plane" /> Process File
                                    </a>
                                    <a
                                        href={null}
                                        className="btn btn-inverse btn-fill"
                                        type="button"
                                        onClick={() => {
                                            refInputFile.value = null;
                                            this.tempFile = null;
                                            this.setState({
                                                fileName: '',
                                                parsedFile: [],
                                                loading: false,
                                                errorMessage: [],
                                            });
                                        }}
                                    >
                                        <i className="fa fa-recycle" /> Reset
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <p style={{ textAlign: 'center' }}>
                            <i className="fa fa-2x fa-spinner fa-spin" />
                        </p>
                    ) : null}
                </div>
                <div className="clearfix" />
                <div className="row" style={{ marginTop: 20 }}>
                    {
                        errorMessage.length > 0 ? (
                            <div className="alert alert-warning">
                                <h4>Some error(s) occured:</h4>
                                {errorMessage.map(o => <p style={{ fontWeight: 'bold' }}>{o}</p>)}
                            </div>
                        ) : null
                    }
                </div>
                {
                    parsedFile.length > 0 ? (
                        <div className="row">
                            {this.state.validationError && <span className="icon-warning">Validation Error: found [{this.state.validation.length}] validation error on this file!</span>}
                            <a href={null} className="btn btn-info btn-fill pull-right" type="button" onClick={this.createApplication} disabled={this.state.validationError}>
                                <i className="fa fa-upload" /> Upload
                            </a>
                            <div className="clearfix" />
                            <ReactTable
                                data={parsedFile}
                                columns={this.getUploadColumns()}
                                className="-striped -highlight"
                                
                            />
                        </div>
                    ) : null
                }
            </div>
        );
    }
}

BeneUpload.propTypes = {
    user: propTypes.object.isRequired,
    salesforce: propTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
});


export default connect(mapStateToProps, mapDispatchToProps)(BeneUpload);



//////////////////
// WEBPACK FOOTER
// ./src/components/BeneUpload/BeneUpload.js
// module id = 1001
// module chunks = 0